import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData,
  type DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError,
  type DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse,
  deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete,
} from '../../generated';

export type DeleteAssetImageMutationVariables = DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData['path'];

export type DeleteAssetImageMutation = DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse;

export const useDeleteAssetImageMutation = <
  TError = DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteAssetImageMutation, TError, DeleteAssetImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteAssetImageMutation, TError, DeleteAssetImageMutationVariables, TContext>({
    mutationKey: ['DeleteAssetImage'],
    mutationFn: async ({ portfolio_id, image_id }: DeleteAssetImageMutationVariables) => {
      const { data } = await deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete({
        path: { portfolio_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeleteAssetImageMutation.fetcher = (
  { portfolio_id, image_id }: DeleteAssetImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete({
      path: { portfolio_id, image_id },
      throwOnError: true,
    });
    return data;
  };
};
